var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pages > 1 && _vm.activeIndex < _vm.pages)?_c('div',{ref:"scrollReference",staticClass:"catalogue-load-more catalogue-pagination normal arial centered light"}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efadebe4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/CatalogResultsNavigation.vue
// module id = 517
// module chunks = 0